
import { Component, Vue } from "vue-property-decorator";
import { Route, RawLocation } from "vue-router";
import { API_ROUTES } from "@/utils/API";
import { API_TCandidate } from "@/models/company_candidates";

import { CANDIDATE_ASSESSMENT_SERVICE, START_SERVICE_EVENT } from "@/constants/services";

const INVITE_CANDIDATE_ROUTE = "InviteCandidate";

const VALUE_NAME = "name";
const VALUE_JOB_POSITION = "job_position";
const VALUE_ASS_RESULT = "ass_result";

const MIDDLE = "middle";

const STATUS_COLUMN_CLASS = "status";

Component.registerHooks(["beforeRouteEnter"]);

@Component({
  components: {
    Loader: () => import("@/components/Loader/Loader.vue"),
    IconButtonBlock: () =>
      import("@/modules/Compliance/Blocks/IconButtonBlock/IconButtonBlock.vue"),
    PopupSkilledWorkerVisaService: () =>
      import("@/modules/Compliance/Popups/PopupSkilledWorkerVisaService.vue"),
    SubmitRequestVisaPopUp: () => import("@/components/Popups/SubmitRequestVisaPopUp.vue"),
  },
})
export default class EmployerServicesCandidates extends Vue {
  loading = false;

  candidates: API_TCandidate[] = [];

  selectedCandidate = {
    id: 0,
    isOutside: false,
  };

  showSkilledWorkerPopup = false;

  openSkilledWorkerPopup() {
    this.showSkilledWorkerPopup = true;
  }

  closeSkilledWorkerPopup() {
    this.showSkilledWorkerPopup = false;

    this.openSubmitRequestVisaPopup();
  }

  submitRequestVisaPopup = false;

  openSubmitRequestVisaPopup(): void {
    this.submitRequestVisaPopup = true;
  }

  closeSubmitRequestVisaPopup(): void {
    this.submitRequestVisaPopup = false;
  }

  async inviteCandidate() {
    const query = {
      event: START_SERVICE_EVENT,
      service: CANDIDATE_ASSESSMENT_SERVICE,
    };

    await this.$router.push({
      name: INVITE_CANDIDATE_ROUTE,
      query,
    });
  }

  selectCandidate(id: number, isOutside: boolean) {
    this.selectedCandidate = {
      id,
      isOutside,
    };

    this.openSkilledWorkerPopup();
  }

  async fetchCandidates(): Promise<void> {
    try {
      this.loading = true;

      const { data } = await this.axios.get<API_TCandidate[]>(API_ROUTES.COMPANY_CANDIDATES);

      if (!data) return;

      this.candidates = data;
    } finally {
      this.loading = false;
    }
  }

  beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: RawLocation | ((vm: Vue) => void)) => void
  ): void {
    next((vm: any) => {
      vm.fetchCandidates();
    });
  }

  get attributes() {
    const { headers, candidates, labels, loading } = this;
    return {
      headers,
      items: candidates,
      labels,
      loading,
      verticalAlign: MIDDLE,
    };
  }

  headers = [
    {
      text: this.$t("table.headers.name"),
      value: VALUE_NAME,
      filterable: true,
    },
    {
      text: this.$t("table.headers.jobPosition"),
      value: VALUE_JOB_POSITION,
      filterable: true,
    },

    {
      text: this.$t("table.headers.eligibilityCheckResult"),
      value: VALUE_ASS_RESULT,
      slot: true,
      filterable: true,
    },
    {
      text: "",
      value: "select",
      slot: true,
      align: "right",
      width: "150",
    },
  ];

  get labels() {
    return {
      allLabel: this.$t("table.allLabel"),
      placeholderLabel: this.$t("table.placeholderLabel"),
    };
  }

  resultClasses(decision: string) {
    return {
      [`${STATUS_COLUMN_CLASS}_low-risk`]: decision.includes("Low risk"),
      [`${STATUS_COLUMN_CLASS}_medium-risk`]: decision.includes("Medium risk"),
      [`${STATUS_COLUMN_CLASS}_high-risk`]: decision.includes("High risk"),
      [`${STATUS_COLUMN_CLASS}_approved`]: decision.includes("Approved"),
      [`${STATUS_COLUMN_CLASS}_rejected`]: decision.includes("Rejected"),
    };
  }
}
